/* Dough Dough — storefront nav dropdowns.
   1) Builds a "How To" dropdown by folding the flat guide links together.
   2) Converts the existing "Recipes" and "Tools" top-level items into
      hover dropdowns (in place, still clickable), reusing the theme's own
      dropdown markup so they match Revival Instructions exactly.
   Desktop only (mobile drawer keeps flat links). Defensive + idempotent. */
(function () {
  if (typeof document === "undefined") return;

  var GUIDES = [
    { t: "Your First Loaf",             u: "/pages/your-first-sourdough-loaf-start-to-finish" },
    { t: "How I Bake (Kit & Method)",   u: "/pages/how-i-bake" },
    { t: "Flour Guide",                 u: "/pages/flour-guide" },
    { t: "Stretch & Folds",             u: "/pages/how-to-stretch-and-fold-sourdough" },
    { t: "How to Shape Dough",          u: "/pages/how-to-shape-dough" },
    { t: "How to Score Bread",          u: "/pages/how-to-score-sourdough-bread" },
    { t: "Bake in a Cast Iron Pot",     u: "/pages/how-to-bake-sourdough-in-a-cast-iron-pot" },
    { t: "Bulk Fermentation",           u: "/pages/how-to-tell-when-bulk-fermentation-is-done" },
    { t: "Feed & Care for Your Starter", u: "/pages/how-to-feed-care-for-your-sourdough-starter" },
    { t: "Starter Troubleshooting",     u: "/pages/sourdough-starter-troubleshooting" },
    { t: "Loaf Troubleshooting",        u: "/pages/sourdough-loaf-troubleshooting" },
    { t: "Make Sourdough Pizza",        u: "/pages/how-to-make-sourdough-pizza" },
    { t: "Freeze & Refresh Bread",       u: "/pages/how-to-freeze-refresh-sourdough-bread" }
  ];

  var RECIPES = [
    { t: "Browse All Recipes",      u: "/pages/simple-sourdough-bread-recipe" },
    { t: "Simple White Loaf",       u: "/pages/simple-sourdough-white-loaf" },
    { t: "Sandwich Loaf",           u: "/pages/sourdough-sandwich-loaf" },
    { t: "Focaccia",                u: "/pages/sourdough-focaccia" },
    { t: "Discard Pancakes",        u: "/pages/sourdough-discard-pancakes" },
    { t: "Whole Wheat Loaf",        u: "/pages/whole-wheat-sourdough" },
    { t: "Dinner Rolls",            u: "/pages/sourdough-dinner-rolls" },
    { t: "Seeded Batard",           u: "/pages/seeded-sourdough-batard" },
    { t: "Open Crumb Loaf",         u: "/pages/high-hydration-open-crumb-loaf" },
    { t: "Overnight Country Bread", u: "/pages/overnight-country-bread-ken-forkish-style" },
    { t: "Tartine Country Bread",   u: "/pages/tartine-style-country-bread" },
    { t: "Bread Machine Loaf",      u: "/pages/bread-machine-sourdough-loaf" },
    { t: "Rye Bread",               u: "/pages/sourdough-rye-bread" },
    { t: "Bagels",                  u: "/pages/sourdough-bagels" },
    { t: "English Muffins",         u: "/pages/sourdough-english-muffins" },
    { t: "Cinnamon Rolls",          u: "/pages/sourdough-cinnamon-rolls" },
    { t: "Pretzels",                u: "/pages/sourdough-pretzels" },
    { t: "Crackers",                u: "/pages/sourdough-crackers" },
    { t: "Pitta Breads",            u: "/pages/sourdough-pitta-breads" },
    { t: "Baguettes",               u: "/pages/sourdough-baguettes" },
    { t: "Baguettes \u00e0 l'Ancienne", u: "/pages/baguettes-a-lancienne" },
    { t: "Rustic Ciabatta",          u: "/pages/rustic-ciabatta" },
    { t: "Flaky Puff-Crust Pizza",  u: "/pages/flaky-puff-crust-pizza" }
  ];

  var TOOLS = [
    { t: "All Tools",                   u: "/pages/tools" },
    { t: "Recipe Scaler",               u: "/pages/tools#recipe-scaler" },
    { t: "Bread Maker Converter",       u: "/pages/tools#bread-maker-converter" },
    { t: "DDT Calculator",              u: "/pages/tools#ddt" },
    { t: "Starter Hydration Converter", u: "/pages/tools#hydration-converter" },
    { t: "Starter Revival Wizard",      u: "/pages/tools#starter-revival-wizard" },
    { t: "Yeast to Sourdough Converter", u: "/pages/tools#yeast-converter" },
    { t: "Bake-Day Timeline Calculator", u: "/pages/tools#bake-day-timeline" },
    { t: "Flavour & Texture Profiler",  u: "/pages/tools#flavour-profiler" },
    { t: "Fermentation Temp Adjuster",  u: "/pages/tools#fermentation-adjuster" },
    { t: "Multi-Loaf Yield Planner",    u: "/pages/tools#yield-planner" },
    { t: "Starter Care Guide",          u: "/pages/tools#starter-care-guide" },
    { t: "Starter Strength Tracker",    u: "/pages/tools#starter-tracker" },
    { t: "Loaf Score Card Generator",   u: "/pages/tools#loaf-score-card" },
    { t: "Hydration Visual Guide",      u: "/pages/tools#hydration-guide" },
    { t: "Flour Blend Analyst",         u: "/pages/tools#flour-blend" },
    { t: "Discard Reincarnation Engine", u: "/pages/tools#discard" },
    { t: "Interactive Baking Matrix",   u: "/pages/tools#baking-matrix" },
    { t: "Combustion Probe Profile",    u: "/pages/tools#combustion" },
    { t: "Sourdough Jargon Decoder",    u: "/pages/tools#glossary" }
  ];

  var URLS = GUIDES.map(function (g) { return g.u; });
  function isGuide(href) {
    if (!href) return false;
    for (var i = 0; i < URLS.length; i++) if (href.indexOf(URLS[i]) !== -1) return true;
    return false;
  }
  function setLeadText(a, text) {
    var kids = [].slice.call(a.childNodes);
    for (var i = 0; i < kids.length; i++) if (kids[i].nodeType === 3) a.removeChild(kids[i]);
    a.insertBefore(document.createTextNode(text + " "), a.firstChild);
  }
  // a native theme dropdown to copy markup from (not one we created)
  function nativeTemplate() {
    var all = [].slice.call(document.querySelectorAll(".m-menu__item--dropdown"));
    for (var i = 0; i < all.length; i++) {
      var li = all[i];
      if (!li.hasAttribute("data-dd-howto") && !li.hasAttribute("data-dd-recipes") && !li.hasAttribute("data-dd-tools")) return li;
    }
    return all[0] || null;
  }

  /* ---------- How To (built from scratch; folds flat guide links in) ---------- */
  function buildHowTo() {
    var mains = [].slice.call(document.querySelectorAll("a.m-menu__link--main"));
    var groups = [];
    mains.forEach(function (a) {
      if (!isGuide(a.getAttribute("href"))) return;
      var li = a.closest(".m-menu__item");
      if (!li || li.classList.contains("m-menu__item--dropdown")) return;
      var ul = li.parentNode;
      var g = null;
      for (var i = 0; i < groups.length; i++) if (groups[i].ul === ul) g = groups[i];
      if (!g) { g = { ul: ul, lis: [] }; groups.push(g); }
      g.lis.push(li);
    });
    groups.forEach(function (g) {
      if (g.ul.querySelector(":scope > [data-dd-howto]")) return;
      var tmpl = g.ul.querySelector(":scope > .m-menu__item--dropdown") || nativeTemplate();
      if (!tmpl) return;
      var howto = tmpl.cloneNode(true);
      howto.setAttribute("data-dd-howto", "1");
      howto.removeAttribute("data-dd-recipes");
      howto.removeAttribute("data-dd-tools");
      var mainA = howto.querySelector("a.m-menu__link--main");
      if (mainA) { mainA.setAttribute("href", "/pages/flour-guide"); setLeadText(mainA, "How To"); }
      var sub = howto.querySelector(".m-sub-menu");
      if (sub) {
        var liT = sub.querySelector(".m-sub-menu__item");
        if (liT) {
          sub.innerHTML = "";
          GUIDES.forEach(function (gd) {
            var li = liT.cloneNode(true);
            var a = li.querySelector("a");
            if (a) { a.setAttribute("href", gd.u); a.textContent = gd.t; }
            sub.appendChild(li);
          });
        }
        var mega = howto.querySelector(".m-mega-menu");
        if (mega) mega.style.setProperty("--total-columns", "1");
      }
      g.ul.insertBefore(howto, g.lis[0]);
      g.lis.forEach(function (li) { if (li.parentNode) li.parentNode.removeChild(li); });
    });
  }

  /* ---------- Convert an existing top-level item into a dropdown ---------- */
  function enhanceDropdown(hrefMatch, items, cols, flag, panelW) {
    var tmpl = nativeTemplate();
    if (!tmpl) return;
    var megaTmpl = tmpl.querySelector(".m-mega-menu");
    if (!megaTmpl) return;
    var mains = [].slice.call(document.querySelectorAll("a.m-menu__link--main"));
    mains.forEach(function (a) {
      var href = a.getAttribute("href") || "";
      if (href.indexOf(hrefMatch) === -1) return;
      var li = a.closest(".m-menu__item");
      if (!li || li.hasAttribute(flag)) return;
      if (li.classList.contains("m-menu__item--dropdown") && !li.hasAttribute(flag)) {
        // already a real dropdown in the menu — leave it alone
        if (!li.querySelector(".m-mega-menu")) { /* fall through to build */ } else return;
      }
      li.setAttribute(flag, "1");
      li.classList.add("m-menu__item--parent", "m-menu__item--has-submenu", "m-menu__item--dropdown");
      // arrow on the main link
      if (!a.querySelector(".m-menu__arrow")) {
        var arrowSrc = tmpl.querySelector("a.m-menu__link--main .m-menu__arrow");
        if (arrowSrc) a.appendChild(arrowSrc.cloneNode(true));
      }
      // build the panel
      var mega = megaTmpl.cloneNode(true);
      // force the panel wide enough (theme caps it ~250px) — inline beats theme CSS
      if (panelW) {
        mega.style.width = panelW + "px";
        mega.style.maxWidth = "none";
        var cont = mega.querySelector(".m-mega-menu__container");
        var inner = mega.querySelector(".m-mega-menu__inner");
        if (cont) { cont.style.width = panelW + "px"; cont.style.maxWidth = "none"; }
        if (inner) { inner.style.width = panelW + "px"; inner.style.minWidth = panelW + "px"; inner.style.maxWidth = "none"; }
      }
      var sub = mega.querySelector(".m-sub-menu");
      var liT = sub ? sub.querySelector(".m-sub-menu__item") : null;
      if (sub && liT) {
        sub.innerHTML = "";
        items.forEach(function (it) {
          var sli = liT.cloneNode(true);
          var sa = sli.querySelector("a");
          if (sa) { sa.setAttribute("href", it.u); sa.textContent = it.t; }
          sub.appendChild(sli);
        });
        if (cols > 1) {
          sub.style.display = "block";        // CSS columns need a block container
          sub.style.columnCount = cols;
          sub.style.columnGap = "1.5rem";
        }
      }
      mega.style.setProperty("--total-columns", cols);
      li.appendChild(mega);
    });
  }

  function run() {
    try { buildHowTo(); } catch (e) {}
    try { enhanceDropdown("/pages/simple-sourdough-bread-recipe", RECIPES, 2, "data-dd-recipes", 460); } catch (e) {}
    try { enhanceDropdown("/pages/tools", TOOLS, 2, "data-dd-tools", 500); } catch (e) {}
    // reveal the menu once it's been restructured (kills the flat-menu flash)
    document.documentElement.classList.add("dd-nav-ready");
  }

  // column layout for the wide Tools panel + tidy recipe list
  var st = document.createElement("style");
  st.id = "dd-nav-dd-style";
  st.textContent =
    '.m-menu__item[data-dd-recipes] .m-sub-menu__item,.m-menu__item[data-dd-tools] .m-sub-menu__item{break-inside:avoid;}';
  if (!document.getElementById("dd-nav-dd-style")) document.head.appendChild(st);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
  setTimeout(run, 600);
  setTimeout(run, 1500);
})();
